import ContractList from "../../fragments/contract-list";


function CustomerContractsList({ customerId }) {
  return <ContractList contractObjectType={"customer"} contractObjectId={customerId} navigationBasePath={`/customer/${customerId}/contracts`} />
}

export default CustomerContractsList;